// @flow
import * as React from 'react';
import styled from 'styled-components';
import DatePicker from 'components/DatePicker';
import { BorderlessButton } from 'components/Button';
import Container from 'components/Container';
import { colors } from '../theme';

const AddRemoveButton = styled(BorderlessButton)`
  font-size: 32px;
  transition: color 0.2s ease-in;
  &:hover {
    color: ${colors.turtleGreen};
  }
  &:disabled {
    color: ${colors.coolGrey};
  }
`;

const MultiDatePicker = ({
  id,
  name,
  values,
  maxInputs,
  onChange,
  hasError,
  ...props
}: {
  id?: string,
  name: string,
  values: Array<?string>,
  maxInputs: number,
  onChange: (Array<?string>) => void,
  hasError?: boolean,
  'data-qa-id': string
}) => {
  values = values.length !== 0 ? values : [''];

  const onInputChange = index => (value: ?string) => {
    values[index] = value;
    onChange(values);
  };
  const addInputClicked = () => {
    values.push('');
    onChange(values);
  };
  const removeInputClicked = () => {
    values.pop();
    onChange(values);
  };
  const inputId = index => {
    if (!id) return undefined;
    return index === 0 ? id : `${id}-${index + 1}`;
  };

  return (
    <>
      {values.map((value, index) => (
        <Container
          mb="8px"
          key={index} // eslint-disable-line react/no-array-index-key
        >
          <DatePicker
            id={inputId(index)}
            value={value}
            onChange={onInputChange(index)}
            hasError={hasError}
            {...props}
          />
        </Container>
      ))}
      <AddRemoveButton
        mr="10px"
        p="0"
        disabled={values.length === maxInputs}
        data-qa-id={`${props['data-qa-id']}-add`}
        onClick={addInputClicked}
      >
        + {/* TODO: use icon */}
      </AddRemoveButton>
      <AddRemoveButton
        p="0"
        disabled={values.length === 1}
        data-qa-id={`${props['data-qa-id']}-remove`}
        onClick={removeInputClicked}
      >
        - {/* TODO: use icon */}
      </AddRemoveButton>
    </>
  );
};

export default MultiDatePicker;
